<template>
  <div>
    <SectionBuilder v-bind="anchorMenuSectionBuilder" />
  </div>
</template>
<script setup lang="ts">
import SectionBuilder from '~/components/Organisms/SectionBuilder/SectionBuilder.vue';
import type { AnchorMenuSection } from '~/sanity/types';

defineProps<AnchorMenuSection>();
</script>

<style lang="scss" scoped></style>
